export enum MI_MULTIPLIER_DICE_ASSETS {
  BACKGROUND = 'background.png',
  DICE = 'dice.png',
  DICE_INTRO_ANIMATION_KEY = 'mi-multiplier-dice-intro',
  LIGHTING = 'lighting.png',
  LOGO = 'kicker-logo.png',
  NUMBER_SUFFIX = 'x.png',
  NUMBER_GLOW_SUFFIX = 'x-Glow.png',
  SHADOW = 'shadow.png',
}

export enum MI_MULTIPLIER_DICE_TEXTURE_KEYS {
  ATLAS = 'MI_MULTIPLIER_DICE_ATLAS',
  DICE_INTRO = 'MI_MULTIPLIER_DICE_INTRO',
  DICE = 'MI_MULTIPLIER_DICE_DICE',
}

export const preLoadAssets = (scene: Phaser.Scene) => {
  const prefix = `/add-ons/multiplier/dice/`

  if (!scene.textures.getTextureKeys().includes(MI_MULTIPLIER_DICE_TEXTURE_KEYS.ATLAS)) {
    scene.load.atlas(
      MI_MULTIPLIER_DICE_TEXTURE_KEYS.ATLAS,
      `${prefix}multiplier-dice-images-0.png`,
      `${prefix}multiplier-dice-images.json`,
    )
  }

  scene.load.spritesheet({
    key: MI_MULTIPLIER_DICE_TEXTURE_KEYS.DICE_INTRO,
    url: `${prefix}images/dice-kicker-intro.png`,
    frameConfig: {
      frameWidth: 300,
      frameHeight: 300,
    },
  })
}
